import { Text, Box, VStack } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface ClaimsCardProps {
  data?: any;
}

const UnknownOperatorClaimsCard = ({ data }: ClaimsCardProps) => {
  const colors = useBinderCardColors();
  const drivers = data?.drivers || [];

  // Common headers for all claims tables
  const claimsHeaders = ['Date', 'Driver', 'Type', 'Fault', 'Payout'];

  // Format empty value display
  const formatEmptyValue = (value: string) => {
    if (!value || value.trim() === '') {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }
    return value;
  };

  // Create table rows from claims data
  const createClaimsRows = (claims: any[]) => {
    if (claims.length === 0) {
      return [];
    }

    return claims.map((claim: any) => [
      formatEmptyValue(claim.date),
      formatEmptyValue(claim.driver),
      formatEmptyValue(claim.type),
      formatEmptyValue(claim.fault),
      formatEmptyValue(claim.payout),
    ]);
  };

  // Handle case when no drivers have claims data
  if (drivers.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No driver claims data available
        </Text>
      </Box>
    );
  }

  return (
    <VStack spacing={6} align="stretch">
      {drivers.map((driver: any, index: number) => (
        <Box key={index}>
          <VStack spacing={3} align="stretch">
            {/* Claims (AutoPlus) Table */}
            {driver.claims?.length > 0 && (
              <DataTableCard
                description="Unknown Operator Claims"
                headers={claimsHeaders}
                rows={createClaimsRows(driver.claims)}
              />
            )}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
};

export default UnknownOperatorClaimsCard;
